import { uploadSppb } from '../../../helper';
import { setSppbInfoDialogVisibility, uploadingSppb } from '../simple-action';

export default values => async (dispatch, getState) => {
  try {
    dispatch(uploadingSppb(true));

    const { token } = getState().authentication;

    const response = await uploadSppb(values, token);

    dispatch(setSppbInfoDialogVisibility(true, response.message));
  } finally {
    dispatch(uploadingSppb(false));
  }
};
